import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePub } from '../../hooks/usePubSub';
import { timeout, playDelay } from '../../utils/utils';
import { selectTrack, setPlaylist } from '../../features/audioPlayer/audioPlayerSlice';
import { ReactComponent as PlayButton } from '../../assets/images/track_controls/play_icon.svg';
import { ReactComponent as PauseButton } from '../../assets/images/track_controls/pause_icon.svg';
import './tracks-play-pause.css';

const TracksPlayPauseButton = ({track, playlist, large = false}) => {
  	const dispatch = useDispatch();
	const publish = usePub();
  	const trackIsPlaying = useSelector(state => state.audioPlayer.trackIsPlaying);
	const currentTrack = useSelector(state => state.audioPlayer.currentTrack);
	
    
    // TODO move this into utils
    const handlePlayPauseClick = async (event, track) => {
      event.stopPropagation();
			let changedSelection = false;
        
			// select the track if it is not the current track
			if (!currentTrack || (currentTrack && currentTrack.id !== track.id)) {
				changedSelection = true;
				dispatch(selectTrack(track));
				dispatch(setPlaylist(playlist));
			}
			// handle play/pause
			if (changedSelection) {
				await timeout(playDelay); // allow next audio source to load
				publish('audioPlayerEvent',{action:'play', track: track})
			} else {
				if (!trackIsPlaying) {
					publish('audioPlayerEvent',{action:'play', track: track})
				} else {
					publish('audioPlayerEvent',{action:'pause', track: track})
				}
			}
    };

    
    return (
        <div className={`tracks-play-pause-container ${large ? 'tracks-play-pause-large' : ''} `}
            onClick={(event) => handlePlayPauseClick(event, track)}
        >
            {(currentTrack && currentTrack.id === track.id) ?
                trackIsPlaying ? <PauseButton className='tracks-play-pause-button'/> : <PlayButton className='tracks-play-pause-button'/>
                :
                <PlayButton className='tracks-play-pause-button'/>
            }
        </div>
    );
}

export default TracksPlayPauseButton;